// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyABdm8Pv9mXZEkrL5WQz7tXTzr9Nel---I",
    authDomain: "login-2b80a.firebaseapp.com",
    projectId: "login-2b80a",
    storageBucket: "login-2b80a.appspot.com",
    messagingSenderId: "963827538701",
    appId: "1:963827538701:web:ca5f66358bc8655e9aae44",
    measurementId: "G-NV025Q5FGQ"
};
const firebase = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service



export default firebase